import _styled from "styled-components";
const _excluded = ["style", "disabled", "error", "isLoading", "placeholder", "renderControl", "renderMenu"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import MultiAutocompleteControl from './Control/MultiAutocompleteControl';
import DropdownMenu from './Menu/DropdownMenu';
import { useMultiAutocomplete } from '../hooks';
const defaultRenderControl = args => /*#__PURE__*/React.createElement(MultiAutocompleteControl, args);

/**
 * A multi select, searchable dropdown component.
 *
 * This component covers the majority of use cases, but advanced use cases may require using the `useMultiAutocomplete` hook directly.
 */
const Autocomplete = _ref => {
  let {
      style,
      disabled,
      error,
      isLoading,
      placeholder,
      renderControl = defaultRenderControl,
      renderMenu = DropdownMenu.render
    } = _ref,
    args = _objectWithoutProperties(_ref, _excluded);
  const {
    controlProps,
    menuProps,
    virtualProps
  } = useMultiAutocomplete(args);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      width: 300
    }, style]
  }, renderControl(_objectSpread({
    disabled,
    error,
    isLoading,
    placeholder
  }, controlProps)), renderMenu(menuProps, virtualProps));
};
export default Autocomplete;
var _StyledDiv = _styled("div").withConfig({
  displayName: "MultiAutocomplete___StyledDiv",
  componentId: "sc-wb9nyo-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=MultiAutocomplete.js.map